//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Components
import DialogAlertNoInternetConnection from "components/DialogAlertNoInternetConnection/DialogAlertNoInternetConnection";
import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
import MasterRouter from "routes/MasterRouter";
import MainContext from "utils/context/MainContext";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
//#endregion

const App = () => {
	//#region States
	const [unexpectedErrorMessage, setDialogUnexpectedErrorMessage] = useState(null);
	const [closeDialogUnexpectedError, setCloseDialogUnexpectedError] = useState(null);
	//#endregion
	const dialogUnexpectedError = useShowDialogAlert();
	//#region Effects 
	useEffect(() => {
		if (dialogUnexpectedError.value) return;
		setDialogUnexpectedErrorMessage(null);
		setCloseDialogUnexpectedError(null);
	}, [dialogUnexpectedError.value]);
	//#endregion
	//#region Functions
	const reload = error => {
        if (dialogUnexpectedError.value || !error) return;
        setTimeout(() => {
            window.location.reload();
        }, 550);
    }
	//#endregion
	return (
		<>
			<MainContext.Provider value={{ 
				showDialogUnexpectedError: dialogUnexpectedError.value, 
				setShowDialogUnexpectedError: dialogUnexpectedError.set,
				reloadForUnexpectedError: reload, 
				setCloseDialogUnexpectedError: (cb) => setCloseDialogUnexpectedError(() => cb),
				setDialogUnexpectedErrorMessage
			}}>
				<MasterRouter/>
			</MainContext.Provider>
			<DialogAlertNoInternetConnection/>
			<DialogAlertErrorNotify
                show={dialogUnexpectedError.value}
                toggleShow={dialogUnexpectedError.toggle}
				closeDialog={closeDialogUnexpectedError}
				message={unexpectedErrorMessage}/>
		</>
	);
};

export default App;
